import { h } from "preact";
import { t, translate } from "restaumatic-client";
import { NumericStepperButton } from "./NumericStepper";
import { useRef } from "preact/hooks";
export default function CrossSellingBarItem(props) {
    const { title, price, onNameClick, onCtaClick } = props;
    const ref = useRef(null);
    const handleCtaClick = () => {
        var _a;
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.classList.add("is-leaving");
        setTimeout(() => {
            onCtaClick();
        }, 200); // NOTE: value = duration of the CSS animation minus 100ms due to performance lag :D
    };
    return (h("div", { ref: ref, class: "m-crossup__bar-item" },
        h("button", { class: "m-crossup__bar-item-text-btn", onClick: onNameClick, disabled: onNameClick === undefined },
            h("span", { class: "m-crossup__bar-item-title" }, title),
            h("span", { class: "m-crossup__bar-item-price" }, price)),
        h("div", { class: "m-crossup__bar-item-column" },
            h(NumericStepperButton, { type: "increment", onClick: handleCtaClick, ariaLabel: translate(t.restaurants.menu.add), size: "large" }))));
}
